import { getTier, pointsToNextTier } from '../utils/tier';
import { useI18n } from '../i18n';
import './TierBadge.css';

interface Props {
  rating: number;
  size?: 'sm' | 'md' | 'lg';
  showName?: boolean;
  showProgress?: boolean;
}

export function TierBadge({ rating, size = 'md', showName = true, showProgress = false }: Props) {
  const { t } = useI18n();
  const tiers = t.tiers as any;
  const tier = getTier(rating);
  const next = pointsToNextTier(rating);
  const name = tiers[tier.key];

  return (
    <div className={`tier-badge tier-badge--${size}`} style={{ borderColor: tier.color, background: tier.bgColor }}>
      <span className="tier-badge-icon">{tier.icon}</span>
      {showName && <span className="tier-badge-name" style={{ color: tier.color }}>{name}</span>}
      {showProgress && next && (
        <span className="tier-badge-next">
          {next.pointsLeft} → {tiers[next.nextTier.key]}
        </span>
      )}
    </div>
  );
}
